<template>
    <simple-layout
        class="fleets-page"
        :indicators="simpleLayoutIndicators"
        :modelsLoaded="true"
    >
        <h1>Bases</h1>
        <div>
            <div class="page-description">
                <p>
                    Sélectionner la base pour voir les inspections et les véhicules associés dans les pages <strong>Requêtes d'inspection</strong> et <strong>Véhicules</strong>.
                </p>
                <p v-if="$store.getters.userIsAtLeastAdmin">
                    Filtrer par flotte :

                    <el-select
                        v-model="selectedBaseUid"
                        placeholder="Sélectionner une flotte"
                        class="select-group"
                        filterable
                    >
                        <el-option
                            v-for="base in bases"
                            :key="base.uid"
                            :label="base.name"
                            :value="base.uid">
                        </el-option>
                    </el-select>
                </p>
            </div>
            <ns-vue-loader
                :toLoad="requiredData"
                @dataFetched="onDataFetched"
                @dataError="onDataError"
                ref="nsLoader"
            >
                <div slot="content" v-if="contentLoaded">
                    <div class="fleets-grid">
                        <fleet-button
                            v-for="(group, index) in filterGroups"
                            :key="index"
                            :group="group"
                        ></fleet-button>
                    </div>
                </div>
            </ns-vue-loader>
        </div>
    </simple-layout>
</template>

<script>
import FleetButton from './fleet-button.vue';
import NsVueLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loaderV2.vue';
import { mapGetters } from 'vuex';
import schwartz from 'schwartz';

export default {

    components: {
        FleetButton,
        NsVueLoader,
    },

    data () {
        return {
            contentLoaded: false,
            groups: [],
            selectedBaseUid: null,
        };
    },

    watch: {

    },

    computed: {
        ...mapGetters([
            'isBridgestoneUser',
            'simpleLayoutIndicators',
        ]),

        requiredData (){
            return [
                {
                    name: 'groups',
                    model: 'groups',
                },
            ];
        },

        bases(){
            return this.filterArrayWithSchwartz(this.$store.getters.bases);
        },

        isUserFromBridgestone() {
            return this.isBridgestoneUser;
        },

        filterGroups() {
            let groups = this.groups;
            if(this.isBridgestoneUser) {
                if(this.selectedBaseUid){
                    groups = groups.filter(group => {
                        return group.base_uid === this.selectedBaseUid;
                    });
                }
            }
            else{
                groups = groups.filter((group) => {
                    return group.members_uid.includes(this.$store.getters.currentUser.uid);
                });
            }
            return this.filterArrayWithSchwartz(groups);
        }
    },

    methods: {
        onDataFetched (response){
            this.$set(this, 'groups', response.groups);
            this.contentLoaded = true;
        },
        onDataError (error){

        },

        filterArrayWithSchwartz(array) {
            return schwartz(array, (item) => { return item.verbose_name; });
        },
    }
};
</script>

<style lang="scss">
.fleets-page {

    .fleets-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
        grid-auto-rows: 1fr;
        grid-gap: 5px 5px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Fleets/Index.vue